import { render, staticRenderFns } from "./author.vue?vue&type=template&id=91194e6c&scoped=true&"
import script from "./author.vue?vue&type=script&lang=js&"
export * from "./author.vue?vue&type=script&lang=js&"
import style0 from "./author.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./author.vue?vue&type=style&index=1&id=91194e6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91194e6c",
  null
  
)

export default component.exports